
































import { mapGetters } from 'vuex'
import { FlipbookAffectorMode, FlipbookAffectorConfig, FloatPropertyMode } from '../../pfx/emitterConfig'
import PropEditorFloat from "./proped-float.vue";
import { safeParseFloat, formatNumber, findAffector, removeAffector } from '../../utils'

export default {
	name: 'PropEditorAffectorFlipbook',
    components: {
		PropEditorFloat,
    },
    props: {
        onchange: Function, 
        emitter: Object
    },
    enums: {
       FlipbookAffectorMode 
    },
    data: function () {
        return {
        }
    },
    methods: {
        triggerChange: function() {
            this.onchange();
        },
        createAffector: function(initialMode) {
            return {
                mode: initialMode,
                constSpeed: {
                    mode: FloatPropertyMode.Constant,
                    val: 0,
                    min: 0,
                    max: 0
                },
                holdFrame: {
                    mode: FloatPropertyMode.Constant,
                    val: 0,
                    min: 0,
                    max: 0
                },
                loop: true,
                times: [
                    {
                        mode: FloatPropertyMode.Constant,
                        val: 0.5,
                        min: 0,
                        max: 0
                    },
                    {
                        mode: FloatPropertyMode.Constant,
                        val: 0.5,
                        min: 0,
                        max: 0
                    }
                ]
            }
        }
    },
	computed: {
        mode: {
            get() {
                let aff:FlipbookAffectorConfig = findAffector(this.emitter, "flipbook");
                if(!aff)
                    return FlipbookAffectorMode.Disabled;
                return aff.mode;
            },
            set(newVal:number) {
                let aff:FlipbookAffectorConfig = findAffector(this.emitter, "flipbook");
                if(!aff) {
                    aff = this.createAffector(newVal);
                    this.emitter.affectors.push({
                        id: "flipbook",
                        cfg: aff
                    });
                } else {
                    if(newVal == FlipbookAffectorMode.Disabled) {
                        removeAffector(this.emitter, "flipbook")
                    } else {
                        aff.mode = newVal;
                    }
                }

                this.triggerChange();
            }
        },
        constSpeed: {
            get() {
                let aff:FlipbookAffectorConfig = findAffector(this.emitter, "flipbook");
                return aff.constSpeed;
            },
        },
        holdFrame: {
            get() {
                let aff:FlipbookAffectorConfig = findAffector(this.emitter, "flipbook");
                return aff.holdFrame;
            }
        },
        loop: {
            get() {
                let aff:FlipbookAffectorConfig = findAffector(this.emitter, "flipbook");
                return aff.loop;
            },
            set(newVal:boolean) {
                let aff:FlipbookAffectorConfig = findAffector(this.emitter, "flipbook");
                aff.loop = newVal;
                this.triggerChange();
            },
        },
        times0: {
            get() {
                let aff:FlipbookAffectorConfig = findAffector(this.emitter, "flipbook");
                return aff.times[0];
            }
        },
        times1: {
            get() {
                let aff:FlipbookAffectorConfig = findAffector(this.emitter, "flipbook");
                return aff.times[1];
            }
        }
	}
}
